const appConfig = {
  apiBaseUrl: process.env.REACT_APP_API_ENDPOINT,
  pdfBaseUrl: `${process.env.REACT_APP_API_ENDPOINT}bucket/catalogues/`,
  imageBaseUrl: "https://ik.imagekit.io/banjaraexperiences/",
  authenticatedEntryPath: "/app/reservation-dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/app/account/kyc-form",
  enableMock: false,
};

export default appConfig;
